export default "__VITE_ASSET__CnuYsAmZ__"